<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <!-- formulario -->
    <v-row>
      <v-col 
        sm="1" 
        lg="2" 
        class="hidden-xs-only"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              small
              fixed
              exact
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="regresar"
            >
              <v-icon> mdi-arrow-left </v-icon>
            </v-btn>
          </template>
          <span>Regresar</span>
        </v-tooltip>
      </v-col>

      <v-col 
        cols="12" 
        sm="10" 
        lg="8"
      >
        <DetailCard
          :title="`Permisos ${perfil.perfil}`"
          :loading="cardLoading"
        >
          <v-row justify="center">
            <v-col 
              cols="12" 
              sm="10" 
              lg="8"
            >
              <v-form 
                ref="form" 
                v-model="form"
              >
                <v-list
                  flat
                  subheader
                >
                  <v-list-item-group
                    multiple
                    active-class=""
                  >
                    <!-- 1 nivel -->
                    <div v-for="moduloPadre in modulos" 
                      :key="moduloPadre.id_modulo"
                    >
                      <v-list-item>
                        <template v-slot:default="{ active }">
                          <v-list-item-content>
                            <v-list-item-title>{{ moduloPadre.modulo }}</v-list-item-title>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-checkbox 
                              :input-value="active" 
                              v-model="permisos"
                              :value="moduloPadre.id_modulo"
                            >
                            </v-checkbox>
                          </v-list-item-action>
                        </template>
                      </v-list-item>

                      <!-- 2 nivel -->
                      <div v-for="moduloHijo in moduloPadre.modulo_hijo" 
                        :key="moduloHijo.id_modulo"
                      >
                        <v-list-item class="ml-4">
                          <template v-slot:default="{ active }">
                            <v-list-item-content>
                              <v-list-item-title>{{ moduloHijo.modulo }}</v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-checkbox 
                                :input-value="active"
                                v-model="permisos"
                                :value="moduloHijo.id_modulo"
                              >
                              </v-checkbox>
                            </v-list-item-action>
                          </template>
                        </v-list-item>
                      
                        <!-- 3 nivel -->
                        <div v-for="itemModuloHijo in moduloHijo.modulo_hijo" 
                          :key="itemModuloHijo.id_modulo"
                        >
                          <v-list-item class="ml-8">
                            <template v-slot:default="{ active }">
                              <v-list-item-content>
                                <v-list-item-title>{{ itemModuloHijo.modulo }}</v-list-item-title>
                              </v-list-item-content>

                              <v-list-item-action>
                                <v-checkbox 
                                  :input-value="active"
                                  v-model="permisos"
                                  :value="itemModuloHijo.id_modulo"
                                >        
                                </v-checkbox>
                              </v-list-item-action>
                            </template>
                          </v-list-item>
                        </div>
                      </div>
                    </div>
                  </v-list-item-group>
                </v-list>

                <v-btn
                  large
                  block
                  exact
                  elevation="2"
                  color="primary"
                  class="mt-2 mb-6"
                  @click="actualizar"
                >
                  Actualizar
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
        </DetailCard>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Alert from '../../../components/admin/Alert.vue'
import DetailCard from '../../../components/admin/DetailCard.vue';

export default {
  data: () => ({
    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    cardLoading: true,

    form: true,
    loadingForm: false,

    permisos: []
  }),

  mounted() {
    this.$store.dispatch("crearModulos")
    this.$store.dispatch("detallesPerfil", this.$route.params.id_perfil)
        
    this.$store.dispatch("editarPermiso", this.$route.params.id_perfil)
    .then((response) => {
      response.forEach(permiso => {
        this.permisos.push(permiso.modulo_id)
      })
    })
    .catch(() => {});

    setTimeout(() => {
      this.cardLoading = false
    }, 1000)
  },
  
  components: {
    Alert,
    DetailCard
  },

  computed: {
    modulos() {
      return this.$store.getters.obtenerModulos;
    },

    perfil() {
      return this.$store.getters.obtenerPerfil;
    }
  },

  methods: {
    actualizar() {
      this.loadingForm = true
      const permisosPerfil = {
        perfil:   this.$route.params.id_perfil,
        permisos: this.permisos
      }

      this.$store.dispatch("actualizarPermiso", permisosPerfil)
      .then((response) => {
        if (response.status == "success") {
          this.loadingForm  = false;
          let message       = response.message.split(',')

          this.alertType    = "success--text";
          this.alertTitle   = message[0];
          this.alertMessage = message[1];
          this.alert        = true;

          this.$store.dispatch("crearModulosUsuario")
          setTimeout(() => {
            this.$router.replace({ name: "perfil-gestionar" })
          }, 2000)
        } 
        else {
          this.loadingForm  = false
          this.alertType    = "error--text";
          this.alertTitle   = "Error";
          for (const error in response.message) {
            this.alertMessage = response.message[error][0]
          }
          this.alert = true;

          setTimeout(() => {
            this.alert = false
          }, 3000)
        }
      })
      .catch(() => {});
    },

    regresar() {
      this.$router.back()
    }
  }
}
</script>
  